'use client';
import EventCard from './EventCard';
import { useState, useEffect, useRef } from 'react';
import { cn } from 'utils/helpers';
import { useNavigate } from 'react-router-dom';
import { useGetAllMyEventsQuery } from 'services/event.service';
import InfiniteList from './InfiniteList';
import EmptyEventsList from './EmptyEventsList';
import { Loader2 } from 'lucide-react';
import useUpdates from '../hooks/useUpdates';
import { compareEventDates } from './UpcomingEventsSection';
const HostingEventsSection = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [allEvents, setAllEvents] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);

  const { data: events, isFetching } = useGetAllMyEventsQuery({
    status: 1,
    page,
    history: 'false',
  });

  const { updates } = useUpdates();

  useEffect(() => {
    if (events) {
      if (events.length === 0) {
        setHasMore(false);
      }
    }
  }, [events]);

  return (
    <div>
      <div className="w-full flex justify-between items-center px-5  pb-3">
        <p className="text-[1rem] font-bold">
          {allEvents?.length > 0 ? `${allEvents?.length} events` : 'Events'}
        </p>
      </div>
      <div
        className={cn(
          'w-full max-h-[42svh] min-h-[21.75rem] flex flex-col gap-3 overflow-y-scroll',
          updates.length === 0 && 'max-h-[55svh]',
        )}
      >
        <InfiniteList
          onInView={() => {
            if (isFetching || !hasMore) return;

            setPage((prev) => prev + 1);
            setAllEvents((prev) => {
              const combinedEvents = [...prev, ...(events || [])];

              return combinedEvents.sort(compareEventDates);
            });
          }}
          children={
            <div
              className={cn(
                'w-full flex flex-col justify-center items-center gap-3 overflow-y-scroll px-5 mb-[8rem]',
              )}
              id="scrollableDiv"
            >
              {allEvents.length > 0 ? (
                allEvents
                  .sort(compareEventDates)
                  .map((event: any, index: number) => (
                    <div
                      className="w-full flex"
                      key={index}
                      onClick={() => {
                        navigate(`/lets-meet/view/${event.event._id}`);
                      }}
                    >
                      <EventCard
                        title={event.event.activity}
                        description={event.event.details}
                        startTime={event.event.start}
                        endTime={event.event.end}
                        emoji={event.event.emoji || '📅'}
                        organizerId={event.event.userId}
                        status={event.event.status}
                        organizerName={event.event.organizer}
                      />
                    </div>
                  ))
              ) : (
                <>
                  {!isFetching && allEvents.length === 0 && <EmptyEventsList />}
                  {isFetching && (
                    <div className="flex justify-center items-center">
                      <Loader2 className="w-4 h-4 animate-spin" />
                    </div>
                  )}
                </>
              )}
              {isFetching && (
                <p className="text-center text-gray-500">Loading...</p>
              )}
            </div>
          }
        />
      </div>
    </div>
  );
};

export default HostingEventsSection;
